import React from "react";
import { get, size, filter } from "lodash";

import MenuElement from "./MenuElement";
import MenuElementWithSubMenu from "./MenuElementWithSubMenu";

const MenuElementDynamic = (props) => {
  const { item, solutionsAccess, userLevel, id, permissions } = props;

  const subPages = filter(get(item, ["subPages"]), (p) =>
    get(solutionsAccess, [p.restrict, "allow"])
  );

  if (size(subPages) === 0) return null;

  if (size(subPages) === 1) {
    return (
      <MenuElement
        item={{
          ...item,
          url: get(subPages, [0, "url"]),
        }}
      />
    );
  }

  return (
    <MenuElementWithSubMenu
      item={{
        ...item,
        icons: item.iconsArrow,
      }}
      solutionsAccess={solutionsAccess}
      userLevel={userLevel}
      permissions={permissions}
      id={id}
    />
  );
};

export default MenuElementDynamic;
